import { Stepper, Step, StepLabel, Box, Typography, StepIconProps } from '@mui/material';
import React from 'react';

// Custom Step Icon Component
interface CustomStepIconProps extends StepIconProps {
  icon: React.ReactNode;
}

const CustomStepIcon = (props: CustomStepIconProps) => {
  const { active, completed, icon } = props;

  let backgroundColor = 'transparent';
  let border = '2px solid #D3D3D3';
  let textColor = '#85B5C9';

  if (active) {
    backgroundColor = 'linear-gradient(180deg, #85B5C9 0%, #6CA3AC 100%)';
    textColor = '#FFF';
    border = 'none';
  } else if (completed) {
    backgroundColor = '#85B5C9';
    textColor = '#FFF';
    border = 'none';
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '32px',
        height: '32px',
        borderRadius: '50%',
        background: backgroundColor,
        border,
        color: textColor,
        fontWeight: 'bold',
      }}
    >
      {icon}
    </Box>
  );
};

// Prop validation for CustomStepper
interface CustomStepperProps {
  steps: string[];
  activeStep: number;
}

// Custom Stepper Component
export default function CustomStepper({ steps, activeStep }: CustomStepperProps) {
  const renderStepIcon = (props: StepIconProps & { index: number }) => (
    /* eslint-disable react/prop-types */
    <CustomStepIcon active={props.active} completed={props.completed} icon={props.index + 1} />
  );

  return (
    <Stepper
      activeStep={activeStep}
      alternativeLabel
      sx={{
        width: '100%',
        '& .MuiStepConnector-line': {
          borderColor: '#85B5C9',
        },
      }}
    >
      {steps.map((label, index) => (
        <Step key={label}>
          <StepLabel StepIconComponent={(props) => renderStepIcon({ ...props, index })}>
            <Typography
              variant={activeStep === index ? 'subheadBold' : 'subheadRegular'}
              sx={{
                color: activeStep === index ? '#2A3C67' : '#7CAEBE',
                textAlign: 'center',
              }}
            >
              {label}
            </Typography>
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
}
